

export const agGridValoresGarantizadosDefs = [
    {
        headerName: 'Edad',
        field: 'edad', 
        width: 100
    }, 
    {
        headerName: 'Año',
        field: 'anioPoliza',
        width: 100

    },
    {
        headerName: 'Prima Anual',
        field: 'primaAnualUdi',
        width: 140
    },
    {
        headerName: 'Valor Rescate UDI',
        field: 'valorRescateUdi',
        width: 130
    }, 
     {
        headerName: 'Recuperacion UDI',
        field: 'recuperacionUdi',
        width: 150
    },
    {
        headerName: 'Sum Asegurada',
        field: 'sumaAseguradaUdi',
        width: 200
    }, 
    {
        headerName: 'Valor UDI',
        field: 'valorUdi',
        width: 180
    },
    {
        headerName: 'Prima Anual Pesos',
        field: 'primaAnualPesos',
        width: 250
    },
   {
        headerName: 'Valor Rescate Pesos',
        field: 'valorRescatePesos',
        width: 150
    },
    {
        headerName: 'Recuperacion Pesos',
        field: 'recuperacionPesos',
        width: 150
    },
    {
        headerName: 'Suma Asegurada Pesos',
        field: 'sumaAseguradaPesos',
        width: 270
    } 

]; 
